"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsOsNameEnum = void 0;
var AnalyticsOsNameEnum;
(function (AnalyticsOsNameEnum) {
    AnalyticsOsNameEnum["WINDOWS"] = "windows";
    AnalyticsOsNameEnum["MACOS"] = "macos";
    AnalyticsOsNameEnum["IOS"] = "ios";
    AnalyticsOsNameEnum["ANDROID"] = "android";
    AnalyticsOsNameEnum["LINUX"] = "linux";
    AnalyticsOsNameEnum["OTHER"] = "other";
})(AnalyticsOsNameEnum || (exports.AnalyticsOsNameEnum = AnalyticsOsNameEnum = {}));
